"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoSideBottomBar = TwoSideBottomBar;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)({
  column: {
    display: 'flex',
    flexDirection: 'column'
  }
}, {
  name: 'TwoSideBottomBar'
});
function TwoSideBottomBar(_ref) {
  var leftSide = _ref.leftSide,
    rightSide = _ref.rightSide;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: classes.column,
    item: true,
    xs: 6,
    sm: 5
  }, leftSide), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: classes.column,
    item: true,
    xs: 6,
    sm: 7
  }, rightSide));
}